'use client';

import {PersistStorageKeys} from '@config/persistStorageKeys';
import {createProvidedStore} from './createProvidedStore';
import createZustandStore from './createZustandStore';

interface ICrumbsStore {
    crumbs: string[];
    setCrumbs: (crumb: string[]) => void;
}
const createCrumbStore = (initialState?: Partial<ICrumbsStore>) => {
    return createZustandStore<ICrumbsStore>(
        set => ({
            crumbs: [],
            ...initialState,

            setCrumbs: (crumbs: string[]) =>
                set(state => {
                    state.crumbs = crumbs;
                }),
        }),
        {persistOptions: {name: PersistStorageKeys.CRUMBS}},
    );
};

const store = createProvidedStore(createCrumbStore);
export const useCrumbsStore = store.useStore;
export const withCrumbsStore = store.withStoreProvider;
